<template>
  <PublicLoginForm />
</template>

<script>
import PublicLoginForm from '@/modules/PublicLoginForm'

export default {
  name: 'PublicLogin',
  components: { PublicLoginForm },
  mounted () {
    this.cleanModals()
  },
  methods: {
    cleanModals () {
      // remove unexpected modals which were opened before redirecting to Login
      const modals = Array.from($('.reveal-overlay'))
      // clean is-reveal-open class for body element when modals closed
      $('body').removeClass('is-reveal-open')
      modals.forEach(modal => {
        if ($(modal).css('display') !== 'none') {
          $(modal).remove()
        }
      })
    },
  },
}
</script>
